// IMPORTANTE: 
// si añadimos una segunda galería, el data-fancybox="gallery" debe ser diferente, por ejemplo, para la segunda galería pondremos en todos los a data-fancybox="gallery2"


$(document).ready(function(){
    // Recorre cada galería en la página
    $('.module_gallery_fullscreen').each(function(index) {
        // Genera un identificador único para cada galería
        var galleryId = 'gallery' + (index + 1);
        
        // Cambia el data-fancybox a un valor único para cada galería
        $(this).find('a[data-fancybox="gallery"]').attr('data-fancybox', galleryId);
    });

    // Inicializa Fancybox para todas las galerías
    $('[data-fancybox]').fancybox();

    // Elimina la segunda instancia de la galería si existe
    if ($('#elementor-lightbox-slideshow-single-img').length > 0) {
        $('#elementor-lightbox-slideshow-single-img').remove();
    }
});
